import { Grid, makeStyles } from "@material-ui/core";
import { DsIcon, DsText, size } from "@mvp/design-system";
import React from "react";
import { ContinueToGetMessagePassage } from "./ContinueToGetMessagePassage";
import { modalText } from "./modalText";

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    marginBottom: size.xs(theme),
  },
  modalTitle: {
    fontSize: "2.5rem",
    fontWeight: 300,
    color: "rgba(0, 0, 0, 0.87)",
  },
  infoIcon: {
    fontSize: "2.25rem",
    color: '#ECAA00',
    marginRight: size.xs(theme),
  }
}));

export const SubmissionErrorContent: React.FC = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container alignItems="center" wrap="nowrap" className={classes.titleContainer}>
        <DsIcon className={classes.infoIcon} title="" icon="fal fa-exclamation-circle" />
        <DsText
          className={classes.modalTitle}
          variant="h2"
          text={modalText.submissionError.title}
        />
      </Grid>
      <DsText
        variant="body1"
        text={
          modalText.submissionError.unableToSubmit
        }
      />
      
      <ContinueToGetMessagePassage/>
    </>
  );
};
